import {RegistrationNumberGroup} from '../../kit/groups/RegistrationNumberGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function RegistrationDocumentsSubSection() {
  return (
    <VFKit.SubSection data-testid="registration-documents">
      <VFKit.Group data-testid="registration-numbers" columns={[1, 2, 4]}>
        <RegistrationNumberGroup />
      </VFKit.Group>
      <VFKit.Group data-testid="registration-checkboxes" columns={[1, 2, 4]}>
        <VFKit.IsRegisteredCheckbox />
        <VFKit.HasCocCheckbox />
      </VFKit.Group>
      <VFKit.OtherRecordsTextarea />
    </VFKit.SubSection>
  );
}
